/**
 *  How the sign-in page is told that the user did not choose to be there.
 *
 *  A session that cannot be renewed ends in a full page load of `/signin`, which throws away every
 *  bit of in-memory state, so the reason has to travel in the URL. Shared by the side that sends
 *  the user there and the form that explains it, so the two cannot drift apart.
 */

export const SIGN_IN_REASON_PARAMETER = 'reason';

export const SESSION_EXPIRED_REASON = 'session-expired';

/**
 *  Where a session that has run out sends the user.
 */
export const SESSION_EXPIRED_SIGN_IN_URL = `/signin?${SIGN_IN_REASON_PARAMETER}=${SESSION_EXPIRED_REASON}`;

/**
 *  Whether this page load is the end of an expired session.
 *
 *  Read from `window.location` rather than through the router, because the sign-in form is the one
 *  asking and it has no router context of its own — and because the only way to arrive here with
 *  this parameter set is the full page load that ends the session.
 */
export const isSessionExpiredSignIn = () =>
  new URLSearchParams(window.location.search).get(SIGN_IN_REASON_PARAMETER) ===
  SESSION_EXPIRED_REASON;
